var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { OrgUnitTypeEnum } from '@workalizer/shared/enums';
export var isDefaultOrgUnit = function (orgUnit) { return orgUnit.type === OrgUnitTypeEnum.DEFAULT; };
var compareOrgUnits = function (a, b) {
    var aIsDefault = isDefaultOrgUnit(a);
    var bIsDefault = isDefaultOrgUnit(b);
    if (aIsDefault !== bIsDefault)
        return aIsDefault ? 1 : -1;
    return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' });
};
export var buildOrgUnitTree = function (orgUnits) {
    var sortedOrgUnits = __spreadArray([], orgUnits, true).sort(compareOrgUnits);
    var nodesByPath = new Map();
    var roots = [];
    for (var _i = 0, sortedOrgUnits_1 = sortedOrgUnits; _i < sortedOrgUnits_1.length; _i++) {
        var orgUnit = sortedOrgUnits_1[_i];
        var path = orgUnit.path || "/".concat(orgUnit.title);
        nodesByPath.set(path, __assign(__assign({}, orgUnit), { children: [], depth: 0 }));
    }
    for (var _a = 0, sortedOrgUnits_2 = sortedOrgUnits; _a < sortedOrgUnits_2.length; _a++) {
        var orgUnit = sortedOrgUnits_2[_a];
        var path = orgUnit.path || "/".concat(orgUnit.title);
        var node = nodesByPath.get(path);
        if (!node)
            continue;
        var parentPath = orgUnit.parentPath;
        var parent = parentPath && parentPath !== '/' ? nodesByPath.get(parentPath) : null;
        if (parent) {
            node.depth = parent.depth + 1;
            parent.children.push(node);
        }
        else {
            roots.push(node);
        }
    }
    var sortChildren = function (nodes) {
        nodes.sort(compareOrgUnits);
        nodes.forEach(function (node) { return sortChildren(node.children); });
    };
    sortChildren(roots);
    return roots;
};
export var flattenOrgUnitTree = function (nodes, expandedIds) {
    var result = [];
    var walk = function (items) {
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            result.push(item);
            if (item.children.length > 0 && expandedIds.has(item.id)) {
                walk(item.children);
            }
        }
    };
    walk(nodes);
    return result;
};
export var filterOrgUnitTree = function (nodes, query) {
    var normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery)
        return nodes;
    var filterNodes = function (items) {
        return items
            .map(function (item) {
            var filteredChildren = filterNodes(item.children);
            var matches = item.title.toLowerCase().includes(normalizedQuery);
            if (!matches && filteredChildren.length === 0) {
                return null;
            }
            return __assign(__assign({}, item), { children: filteredChildren });
        })
            .filter(function (item) { return item !== null; });
    };
    return filterNodes(nodes);
};
export var collectExpandableIds = function (nodes) {
    var ids = [];
    var walk = function (items) {
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            if (item.children.length > 0) {
                ids.push(item.id);
                walk(item.children);
            }
        }
    };
    walk(nodes);
    return ids;
};
